module.exports = __webpack_public_path__ + "b6309cf52dc7937be5e6670df3f81026.fbx";